import React from "react"
import SaleStage from "../components/SaleStage"

class Step2SS extends React.Component {
    render() {

        const { client, updateClient } = this.props;
        const { conditionalSales={} } = (client && client.stages_of_sale) || {};

        const {
            cmapOrPagibigOrCmapCert,
            clearedFirstDownPaymentOrSpotCash,
            approvedClientRequestLetterForConditionalSale,
            additionalOneGovtValidIdWithThreeSpecimen,
            proofOfIncomeCertificateOfEmployment,
            proofOfIncomeThreeMonthsPayslips,
            twoMonthsProofOfBilling,
            birForm1904,
            nsoOrPsaBirthCertificate,
            marriedCertificate,
            courtOrderForLegalSeparationNullityOfMarriage,
            dethCertificate,
            ofwContractOfEmployment,
            ofwWorkingPermits,
            ofwProofOfRemittanceOrBankPassbookStatement,
            ofwPhotocopyOfPassport,
            localLatestTwoYearItr2316,
            selfEmployedBuisnessLatestTwoYearItrWithBirStamp,
            selfEmployedLatestTwoYearsAuditedFinancialStatement,
            selfEmployedSecDti,
            selfEmployedListOfThreeMajorSupplierAndClient,
            selfEmployedCompanyProfile,
            selfEmployedGisIfCorporation,
            selfEmployedSixMonthsBankStatement,
            isCompleted,
            completionDate,
            others=[]
        } = conditionalSales;

        const step2Fields = [
            { key: 'cmapOrPagibigOrCmapCert', type: 'toggle', label: 'CMAP Or Pag-ibig Or CMAP Cert', value: cmapOrPagibigOrCmapCert},
            { key: 'clearedFirstDownPaymentOrSpotCash', type: 'toggle', label: 'Cleared First Down Payment Or SPOT Cash', value: clearedFirstDownPaymentOrSpotCash},
            { key: 'approvedClientRequestLetterForConditionalSale', type: 'file', label: 'Approved Client Request Letter For Conditional Sale', value: approvedClientRequestLetterForConditionalSale},
            { key: 'additionalOneGovtValidIdWithThreeSpecimen', type: 'file', label: 'Additional One Govt Valid Id With Three Specimen', value: additionalOneGovtValidIdWithThreeSpecimen},
            { key: 'proofOfIncomeCertificateOfEmployment', type: 'file', label: 'Proof Of Income Certificate Of Employment', value: proofOfIncomeCertificateOfEmployment},
            { key: 'proofOfIncomeThreeMonthsPayslips', type: 'file', label: 'Proof Of Income Three Months Pay Slips', value: proofOfIncomeThreeMonthsPayslips},
            { key: 'twoMonthsProofOfBilling', type: 'file', label: 'Two Months Proof Of Billing', value: twoMonthsProofOfBilling},
            { key: 'birForm1904', type: 'file', label: 'BIR Form 1904', value: birForm1904},
            { key: 'nsoOrPsaBirthCertificate', type: 'file', label: 'NSO Or PSA Birth Certificate', value: nsoOrPsaBirthCertificate},
            { key: 'marriedCertificate', type: 'file', label: 'Married Certificate', value: marriedCertificate},
            { key: 'courtOrderForLegalSeparationNullityOfMarriage', type: 'file', label: 'Court Order For Legal Separation Nullity Of Marriage', value: courtOrderForLegalSeparationNullityOfMarriage},
            { key: 'dethCertificate', type: 'file', label: 'Death Certificate', value: dethCertificate},
            { key: 'ofwContractOfEmployment', type: 'file', label: 'OFW Contract Of Employment', value: ofwContractOfEmployment},
            { key: 'ofwWorkingPermits', type: 'file', label: 'OFW Working Permits', value: ofwWorkingPermits},
            { key: 'ofwProofOfRemittanceOrBankPassbookStatement', type: 'file', label: 'OFW Proof Of Remittance Or Bank Passbook Statement', value: ofwProofOfRemittanceOrBankPassbookStatement},
            { key: 'ofwPhotocopyOfPassport', type: 'file', label: 'OFW Photocopy Of Passport', value: ofwPhotocopyOfPassport},
            { key: 'localLatestTwoYearItr2316', type: 'file', label: 'Local Latest Two Year ITR 2316', value: localLatestTwoYearItr2316},
            { key: 'selfEmployedBuisnessLatestTwoYearItrWithBirStamp', type: 'file', label: 'Self Employed Business Latest Two Year ITR With Bir Stamp', value: selfEmployedBuisnessLatestTwoYearItrWithBirStamp},
            { key: 'selfEmployedLatestTwoYearsAuditedFinancialStatement', type: 'file', label: 'Self Employed Latest Two Years Audited Financial Statement', value: selfEmployedLatestTwoYearsAuditedFinancialStatement},
            { key: 'selfEmployedSecDti', type: 'file', label: 'Self Employed SEC/DTI', value: selfEmployedSecDti},
            { key: 'selfEmployedListOfThreeMajorSupplierAndClient', type: 'file', label: 'Self Employed List Of Three Major Supplier And Client', value: selfEmployedListOfThreeMajorSupplierAndClient},
            { key: 'selfEmployedCompanyProfile', type: 'file', label: 'Self Employed Company Profile', value: selfEmployedCompanyProfile},
            { key: 'selfEmployedGisIfCorporation', type: 'file', label: 'Self Employed GIS If Corporation', value: selfEmployedGisIfCorporation},
            { key: 'selfEmployedSixMonthsBankStatement', type: 'file', label: 'Self Employed Six Months Bank Statement', value: selfEmployedSixMonthsBankStatement}
            
        ]

        return (
            !!client ? <SaleStage 
                title="Conditional Sales"
                fields={step2Fields}
                isCompleted={isCompleted}
                completionDate={completionDate}
                client={client}
                stage="conditionalSales"
                updateClient={updateClient}
                others={others}
                previousStep={this.props.previousStep}
                nextStep={this.props.nextStep}
            /> : null
        )
    }
}

export default Step2SS
